import styled from 'styled-components';
import paperWhite from '../images/paper_white.jpg';
import paperCream from '../images/paper_cream.jpg';
import paperBlack from '../images/paper_black.jpg';
import paperOrange from '../images/paper_orange.jpg';
import tornPaper from '../images/tornPaper.png';

export const HeaderWrap = styled.header`
  width: 100%;
  height: 220px;
  position: relative;
  overflow: hidden;
  a {
    position: relative;
    display: block;
    width: 100%;
    height: 140px;
  }
  .headerTitle, .headerSubtitle {
    width: 100%;
    font-family: var(--font-family-heading);
    font-weight: bold;
    position: absolute;
    text-align: center;
  }
  .headerTitle {
    color: var(--color-black);
    height: 95px;
    line-height: 1;
    font-size: 50px;
    text-shadow: 1px 1px #fdefc87a;
  }
  .headerTitle span {
    display: inline-block;
    position: absolute;
    left: 0;
    bottom: 10px;
    width: 100%;
    height: 100%;
  }
  .headerTitle span::before {
    display: inline-block;  
    height: 100%;
    vertical-align: baseline;
    content: '';
  }
  .headerSubtitle {
    height: 45px;
    line-height: 1.5;
    top: 95px;
    font-size: 20px;
    color: var(--color-grey);
  }
  .hawksLogo, .saintsLogo {
    width: 130px;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
  }
  .hawksLogo {
    left: 10px;
  }
  .saintsLogo {
    right: 10px;
  }
  @media (min-width: 570px) {
    .headerTitle {
      font-size: calc( 15.384615384615385vw + -37.69230769230769px );
    }
  }
  @media (min-width: 700px) {
    .headerTitle {
      font-size: 70px;
    }
  }
  @media (max-width: 700px) {
    .hawksLogo, .saintsLogo {
      width: 18.5vw;
    }
  }
  @media only screen and (max-width: 500px) {
    .hawksLogo, .saintsLogo {
      display: none;
    }
  }  
`;

export const PageContent = styled.div`
  background-image: url(${paperWhite});
  position: relative;
  min-height: calc(100vh - 300px);
  /* &:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    box-shadow: inset 0px 0px 4px 0px #6b3410;
  } */
`;

export const NavBar = styled.nav`
  ${props => props.isStuck ? `
    position: fixed;
    top: 0;
    height: 60px;
    line-height: 60px;
    font-size: 2rem;
  ` : `
    position: relative;
    font-size: 2.4rem;
    height: 80px;
    line-height: 80px;
  `};
  transition: var(--base-transition);
  z-index: 20;
  display: flex;
  font-weight: bold;
  width: 100%;
  padding: 0;
  background-color: black;
  background-image: url(${paperBlack});
  a {
    font-family: var(--font-family-heading);
    flex: 1;
    color: var(--color-frame);
    text-decoration: none;
    text-align: center;
    white-space: nowrap;
    padding: 0 5px;
    &:hover {
      color: #fdf0c8;
    }
    span {
      @media only screen and (max-width: 550px) {
        display: none;
      }   
    }
  }
`;

export const ClearFloat = styled.div`
  clear: both;
  height: 0;
`;

export const HeadingBox = styled.span`
  /* background: var(--color-grey); */
  /* background: #ff8f17; */
  clear: both;
  padding: 0 3vw;
  h2 {
    border-top: 1px solid var(--color-grey);
    margin: 0;
    padding: 0;
    /* color: var(--color-cream); */
  }
  figure {
    margin-right: auto;
    float: right;
    padding-top: 24px;
    max-width: 300px;
    @media only screen and (max-width: 550px) {
      max-width: 100%;
    }
  }
`

export const ContentBox = styled.section`
  position: relative;
  clear: both;
  overflow: hidden;
  ${props => props.type === 'white' ? `
    background-image: url(${paperWhite});
  ` : ``}
  ${props => props.type === 'black' ? `
    color: var(--color-cream);
    background-image: url(${paperBlack});
  ` : ``}
  ${props => props.type === 'orange' ? `
    color: var(--color-cream);
    background-image: url(${paperOrange});
  ` : ``}
  ${props => (props.type !== 'white' && props.type !== 'black' && props.type !== 'orange') ? `
    background-image: url(${paperCream});
  ` : ``}
  padding: 3vw;
  p:first-of-type {
    &::first-letter {
      font-size: 1.8em;
      font-weight: bold;
    }
  }
  &:after {
    content: "";
    height: 0;
    display: table;
    clear: both;
  }
  &.flexImages {
    figure {
      min-width: 220px;
    }
    figure:nth-child(1) {
      order: 1;
    }
    figure:nth-child(2) {
      order: 2;
    }
    figure:nth-child(3) {
      order: 3;
    }
    @media only screen and (max-width: 872px) {
      figure:nth-child(1) {
      order: 1;
      }
      figure:nth-child(2) {
        order: 3;
      }
      figure:nth-child(3) {
        order: 2;
      }
    }
  }
  ${props => props.flankingImages ? `
    figure {
      min-width: 220px;
    }
    @media only screen and (max-width: 1100px) and (min-width: 550px){
      /*  used in section with TWO photos flanking text*/
      p {  
        clear: both;
      }
      figure {
        width: calc(50% - 10px);
        margin: 0 5px;
      }
    }
    @media only screen and (max-width: 550px) {
      figure: {
        width: 100%;
      }
      img {
        width: 100%;
      }
    }
  ` : ``}
`;

export const FigureFrame = styled.figure`
  position: relative;
  display: block;
  min-width: 240px;
  ${props => props.width ? `
    width: ${props.width};
  `: `
    width: 35%;
  `}
  ${props => props.banded ? `
    width: 100%;
    margin: 0 auto;
    &:after {
      content: '';
      background-image: url(${paperOrange});
      position: absolute;
      height: 50%;
      top: 50%;
      left: -3vw;
      right: -3vw;
      transform: translate(0, -50%);
      z-index: 0;
    }
  ` : ``}
  ${props => props.fullWidth ? `
    width: 100%;
    margin: 0 auto;
    &:after {
      content: '';
      background-image: url(${paperOrange});
      position: absolute;
      height: 50%;
      top: 50%;
      left: -3vw;
      right: -3vw;
      transform: translate(0, -50%);
      z-index: 0;
      }
  ` : ``}
  ${props => props.left ? `
    float: left;
    margin-left: auto;
  ` : ``}
  ${props => props.right ? `
    float: right;
    margin-right: auto;
  ` : ``}
  img {
    position: relative;
    z-index: 1;
    width: 100%;
    ${props => props.fullWidth ? `
      max-width: 80%;
    ` : `
      ${props.maxWidth ? `
        max-width: ${props.maxWidth};
      ` : `
        max-width: 400px;
      `}
    `}
    ${props => props.banded ? `
      margin: ${props.banded === 'left' ? '0 auto 0 3vw' : '0 3vw 0 auto'};
    ` : `
      margin: 0 auto;
    `}
    height: auto;
    display: block;
    border: 4px solid var(--color-frame);
    box-shadow: 0 0 3px 1px rgba(0,0,0,0.3);
    ${props => props.oval ? `
      border-radius: 50%;
      overflow: hidden;
    ` : ``}
  }
  figcaption {
    ${props => props.fullWidth ? `
      max-width: 80%;
    ` : `
      ${props.maxWidth ? `
        max-width: ${props.maxWidth};
      ` : `
        max-width: 400px;
      `}
    `}
    ${props => props.banded ? `
      margin: ${props.banded === 'left' ? '0 auto 0 3vw' : '0 3vw 0 auto'};
    ` : `
      margin: auto;
    `}
    padding-top: 5px;
    font-size: 1.2rem;
    line-height: 1.5;
    display: block;
    caption-side: bottom;
    text-align: center;
  }
  @media only screen and (max-width: 550px) {
    margin: 0 0 0 -3vw;
    float: none;
    width: calc(100% + 6vw);
    max-width: 100vw;
    margin-bottom: 20px;
    img {
      max-width: 100%;
    }
  }
`;

export const Vignette = styled.div`
  position: relative;
  border: 4px solid var(--color-frame);
  box-shadow: 0 0 3px 1px rgba(0,0,0,0.3);
  &:after {
    content: '';
    position: absolute;
    top: 0; left: 0; bottom: 0; right: 0;
    /* box-shadow: inset 0px 0px 150px #645234; */
    box-shadow: inset 0px 0px 60px #000000
  }
`;

export const ParallaxFigCaption = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 1.2rem;
  ${props => props.type === 'white' ? `
    background-image: url(${paperWhite});
  ` : `
    background-image: url(${paperCream});
  `}
`;

export const CarouselWrap = styled.div`
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  .buttons {
    display: flex;
    justify-content: space-between;
    position: absolute;
    width: 100%;
    height: 100%;
  }
  button {
    border: none;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
    opacity: 0.75;
    color: #fe8823;
    text-align: center;
    padding: 0px;
    width: 2.5rem;
    height: 100%;
    margin: 0px;
    z-index: 10;
    cursor: pointer;
    -webkit-appearance: button;
    background-color: transparent;
    background-image: none;
    text-transform: none;
    font-family: inherit;
    font-size: 100%;
    line-height: inherit;
    margin: 0;
    padding: 0;
    &:hover {
      opacity: 1;
      background-color: #1f1f1f;
    }
    &:disabled {
      cursor: default;
      opacity: 0.25;
    }
    svg {
      width: 5rem;
      height: 3rem;
      margin-left: -1.25rem;
      display: block;
      vertical-align: middle;
    }
    span {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border-width: 0;
    }
  }
  .caption {
    transition: 0.5s opacity ease;
    &:hover {
      opacity: .9;
    }
    white-space: normal;
    opacity: 0;
    background-color: #f5ead7;
    width: 100%;
    height: 100%;
    padding: 20px;
    aspect-ratio: 1 / 1;
    display: block;
    z-index: 10;
    left: 0px;
    top: 0px;
    position: absolute;
    color: inherit;
    text-decoration: inherit;
    .title {
      width: calc(100% - 40px);
      left: 20px;
      right: 20px;
      text-align: center;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .innerWrap {
    left: 0;
    height: calc(40vw + 62px);
    scroll-behavior: smooth;
    gap: 0.25rem;
    display: flex;
    scroll-snap-type: x mandatory;
    touch-action: pan-x pan-y pinch-zoom;
    z-index: 0;
    position:  relative;
    &.transition {
      transition: 0.3s all ease;
    }
  }
`;

export const CarouselImage = styled.div`
  position: relative;
  display: inline-block;

  scroll-snap-align: start;

  img {
    height: 100%;
  }
  /*
  div {
    position: absolute;
    bottom: 7px;
    left: 3px;
    right: 3px;
    padding: 5px;
    background: rgba(255,255,255,0.8);
    font-size: 0.8em;
  } */

  /* bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 1.2rem;
  ${props => props.type === 'white' ? `
    background-image: url(${paperWhite});
  ` : `
    background-image: url(${paperCream});
  `} */
`;

export const BackToTopButton = styled.button`
  border: none;
  position: fixed;
  bottom: 20px;
  right: -120px;
  cursor: pointer;
  transition: 0.2s ease all;
  /* visual styling */
  text-decoration: none;
  padding: 10px;
  background: var(--color-black);
  background-image: url(${paperBlack});
  border-radius: 100px;
  white-space: nowrap;
  color: var(--color-cream);
  opacity: 0;
  z-index:10;
  ${props => props.inView ? `
    right: 20px;
    opacity 1;
  ` : ``}
  &:hover {
    animation: clickBounce .5s;
  }
  &:visited {
    color: var(--color-cream);
  }
`;

export const TableOfContents = styled.table`
  width: calc(100% - 6vw);
  padding: 30px 3vw 0;
  td {
    vertical-align: top;
  }
  a {
    font-size: 1.2em;
    font-weight: bold;
    text-decoration: none;
  }
  .part {
    font-weight: bold;
    clear: both;
    float: left;
    font-size: 1.5em;
    width: 100px;
    padding-right: 10px;
    display: inline-block;
    color: var(--color-black);
  }
`;


export const StatsTable = styled.table`
  line-height: 1.5;
  font-size: 10px;
  @media (min-width: 495px) {
    font-size: calc( 1.951219512195122vw + 0.34146341463414664px );
  }
  @media (min-width: 700px) {
    font-size: 14px;
  }
  tr {
    &.NHL {
      font-weight: bold;
    }
    &:nth-child(even) {
      background-color: #ffffff;
    }
    &:nth-child(odd) {
      background-color: #ececec;
    }
    &:last-child {
      background-color: #666666;
      font-weight: bold;
      color: white;
      td {
        white-space: nowrap;
        border: none;
      }
    }
    td {
      text-align: center;
      padding: 0 5px;
      border-left: 1px solid #ccc;
      &.collection {
        padding: 0;
        .titleRow {
          background: #666666;
        }
        div div {
          padding: 0 5px;
          border-left: 1px solid #ccc;
          &:first-child {
            border-left: 0;
          }
        }
      }
      &:first-child {
        border-left: 0;
      }
      &:nth-child(4) {
        background: rgba(0,0,255,0.05);
      }
      &:nth-child(5) {
        background: rgba(0,255,0,0.05);
      }
    }
  }
`;

export const Notice = styled.div`
  background: white;
  width: calc(100% - 2vw);
  margin: 30px 0 0 1vw;
  padding: 20px;
  position: relative;
  box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.3);
  border: 16px solid transparent;
  border-image: 16 repeating-linear-gradient(45deg, #d4afaf 0, #d09999 1em, transparent 0, transparent 2em, #dab8af 0, #dab8af 3em, transparent 0, transparent 4em);
  &:before {
    position: absolute;
    transform: rotate(-0.01turn);
    top: -26px;
    left: -26px;
    content: "NOTICE:";
    display: block;
    color: #b84627;
    font-size: 4rem;
    font-weight: bold;
  }
  .cite {
    color: #a5a5a5;
    font-size: 0.9em;
  }
`;

export const NewsClipping = styled.article`
  background-color: #f9f7f1;
  padding: 10px 20px;
  color: #2f2f2f;
  position: relative;
  margin: 40px 0 40px;
  :before{
    content:" ";
    display: block;
    width: 100%;
    height: 35px;
    background-image: url(${tornPaper});
    background-size: contain;
    background-repeat: repeat-x;
    position: absolute;
    top: -35px;
    left: 0;
    z-index: 1;
    transform: rotateX(180deg) rotateY(180deg);
  }
  :after{
    content:" ";
    display: block;
    height: 35px;
    background-image: url(${tornPaper});
    background-size: contain;
    background-repeat: repeat-x;
    position:  absolute;
    bottom:  -33px;
    width: 100%;
    left: 0;    
    }
/* 
  filter: drop-shadow(-1px 6px 3px rgba(0, 0, 0, 0.5));
  clip-path: polygon(
            1% 2%,
            3.5% 0.1%,
            8.9% 2.7%,
            16.2% 1.2%,
            19.7% 0.8%,
            24.7% 2%,
            31.2% 0%,
            35.9% 2.3%,
            40.6% 0.5%,
            47.1% 1.8%,
            49.9% 1%,
            53.8% 2.5%,
            62.2% 0.4%,
            67.3% 1.2%,
            70.3% 0.3%,
            75.8% 1.4%,
            78.5% 1.7%,
            84% 2.6%,
            91.1% 0.5%,
            93.6% 2.4%,
            97.3% 0.3%,
            98.9% 6%,
            98.1% 11.4%,
            98.6% 15.5%,
            97.3% 17.8%,
            97.7% 27.4%,
            98.3% 28.5%,
            99.7% 34.1%,
            98.8% 41.9%,
            98.3% 45.7%,
            98.4% 50.9%,
            98.7% 57.4%,
            99.6% 60.4%,
            99.4% 66.6%,
            99.2% 69.5%,
            97.4% 77.1%,
            98.1% 82.3%,
            99.9% 83.5%,
            98.2% 91.5%,
            99.3% 95.3%,
            98% 98.6%,
            93.6% 97.4%,
            90.3% 98.3%,
            86.8% 98.3%,
            78.6% 98.5%,
            76.4% 99.2%,
            69.7% 99.8%,
            64.2% 99.3%,
            61.8% 99.2%,
            57.2% 98.1%,
            48.7% 98.3%,
            46.8% 99%,
            39.6% 98.9%,
            33.8% 97.3%,
            28.2% 99.4%,
            27% 98.3%,
            22.1% 98.6%,
            13.1% 97.1%,
            8.7% 99.3%,
            2.7% 97.4%,
            2% 98.2%,
            2.1% 94.3%,
            0.7% 90.5%,
            0.9% 86.3%,
            2.2% 78.2%,
            0.4% 76.7%,
            1.2% 72.1%,
            2% 64%,
            1.4% 59.8%,
            0.4% 57.3%,
            0.3% 49.1%,
            2.9% 44.7%,
            1.9% 41.3%,
            0.8% 35.7%,
            2.9% 31.3%,
            0.8% 24.9%,
            2.7% 20.5%,
            0.8% 17.4%,
            2.5% 8.6%,
            1.1% 5.5%
        ); */
  h2 {
    font-family: 'Playfair Display', serif;
    font-size: 40px;
    text-transform: uppercase;
    padding: 10px 0;
    margin-top: 10px;
    font-weight: bold;
    border-bottom: 1px solid var(--color-grey);
  }
`;